<template>
  <div class="app-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-document-checked"></i> 审批层级</span>
      </div>

      <!-- 查询区域 -->
      <el-form
        :model="queryParams"
        :inline="true"
        label-position="right"
        class="demo-form-inline"
        style="margin-bottom: 20px"
      >
        <el-form-item label="审批名称">
          <el-input
            v-model="queryParams.name"
            placeholder="请输入审批名称"
            clearable
            style="width: 250px"
          />
        </el-form-item>
        <el-row>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="handleQuery(1)"
            >搜索</el-button
          >
          <el-button @click="resetQuery">重置</el-button>
          <el-button type="primary" icon="el-icon-plus" @click="openAddDialog"
            >新增</el-button
          >
        </el-row>
      </el-form>

      <!-- 表格 -->
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        :cell-style="{ textAlign: 'center' }"
        :header-cell-style="{
          background: '#f5f7fa',
          color: '#333',
          fontWeight: 'bold',
          textAlign: 'center',
        }"
      >
        <el-table-column label="名称" prop="name" />
        <el-table-column label="创建人" prop="creatorName" />
        <el-table-column label="创建时间" prop="createTime" />
        <el-table-column label="操作">
          <template v-slot="scope">
            <el-button size="mini" @click="openEditDialog(scope.row)"
              >编辑</el-button
            >
            <el-button size="mini" type="danger" @click="deleteItem(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <pagination-bar
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        @update:pageSize="pageSize = $event"
        @update:currentPage="currentPage = $event"
        @page-change="handleQuery"
      />

      <!-- 弹窗 -->
      <el-dialog
        @close="resetForm"
        :title="isEdit ? '编辑审批流程' : '新增审批流程'"
        :visible.sync="dialogVisible"
        width="630px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form :model="form" ref="form" :rules="rules" label-width="100px">
          <el-form-item label="名称" prop="name">
            <el-select
              v-model="form.name"
              placeholder="请选择名称"
              style="width: 400px"
              @change="handleNameSelectChange"
            >
              <el-option
                v-for="item in nameOptions"
                :key="item.id"
                :label="item.name"
                :value="item.name"
              />
            </el-select>
          </el-form-item>

          <el-form-item
            v-for="(approver, index) in form.approvers"
            :key="index"
            :label="approverLabels[index]"
            :prop="'approvers.' + index"
            :rules="[
              {
                type: 'array',
                required: true,
                message: approverLabels[index] + '不能为空',
                trigger: 'blur',
              },
            ]"
          >
            <el-select
              v-model="form.approvers[index]"
              multiple
              filterable
              clearable
              placeholder="请选择审批人"
              style="width: 400px; margin-right: 20px"
            >
              <el-option
                v-for="user in userOptions"
                :key="user.id"
                :label="user.name"
                :value="user.id"
              />
            </el-select>
            <el-button
              type="text"
              @click="removeApprover(index)"
              v-if="form.approvers.length > 1"
              >删除</el-button
            >
          </el-form-item>

          <el-form-item v-if="form.approvers.length < 3">
            <el-button
              type="primary"
              plain
              icon="el-icon-plus"
              @click="addApprover"
              >添加审批级别</el-button
            >
          </el-form-item>

          <el-form-item label="抄送人" prop="levelCC">
            <el-select
              v-model="form.levelCC"
              multiple
              placeholder="请选择抄送人"
              filterable
              clearable
              style="width: 400px"
            >
              <el-option
                v-for="user in userOptions"
                :key="user.id"
                :label="user.name"
                :value="user.id"
              />
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitForm">保存</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import {
  approvalTemplatePage,
  approvalTemplateAddOrEdit,
  approvalTemplateDelete,
  approvalTemplateDetail,
  applicationType,
} from "@/api/config";
import { staffList } from "@/api/staff";
import PaginationBar from "@/components/PaginationBar";
import { MAX_PAGE_SIZE, levelKeys, APPROVAL_TYPE_2 } from "@/utils/const";
import { isEmpty } from "lodash";

export default {
  components: { PaginationBar },
  data() {
    return {
      queryParams: {
        name: "",
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      dialogVisible: false,
      isEdit: false,
      form: {
        name: "",
        approvers: [[]],
        levelCC: [],
      },
      rules: {
        name: [{ required: true, message: "名称不能为空", trigger: "blur" }],
        levelCC: [
          {
            required: true,
            type: "array",
            message: "请选择抄送人",
            trigger: "blur",
          },
        ],
      },
      approverLabels: ["一级审批", "二级审批", "三级审批"],
      userOptions: [], // 模拟用户数据
      nameOptions: [], //类型数据
      applicationTypeId: "", //申请类型ID
      isScrap: false, // 新增字段：是否为报废类型
    };
  },
  methods: {
    handleNameSelectChange(value) {
      const selectedItem = this.nameOptions.find((item) => {
        return item.name === value;
      });
      if (selectedItem) {
        this.applicationTypeId = selectedItem.id;
        // this.isScrap = selectedItem.name.includes("报废");
        this.isScrap = APPROVAL_TYPE_2.some((keyword) =>
          selectedItem.name.includes(keyword)
        );
      }
    },
    // 查询所有的审批类型
    getApprovalTypeList() {
      applicationType({
        pageNo: 1,
        pageSize: MAX_PAGE_SIZE,
      }).then((res) => {
        this.nameOptions = res.records;
      });
    },
    resetForm() {
      // 重置表单及校验状态
      this.$refs.form.resetFields();
    },
    // 请求所有的职工信息
    getStaffList() {
      const params = {
        pageNo: 1,
        pageSize: MAX_PAGE_SIZE,
      };
      staffList(params)
        .then((res) => {
          // 设置list
          this.userOptions = res.records;
        })
        .catch((err) => {
          console.error("请求失败：", err);
        });
    },
    handleQuery(page) {
      this.currentPage = page || 1;
      approvalTemplatePage({
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        ...this.queryParams,
      }).then((res) => {
        this.tableData = res.records;
        this.total = res.total;
      });
    },
    resetQuery() {
      this.queryParams.name = "";
      this.handleQuery(1);
    },
    openAddDialog() {
      this.isEdit = false;
      this.form = {
        name: "",
        approvers: [[]],
        levelCC: [],
      };
      this.dialogVisible = true;
    },
    openEditDialog(row) {
      this.isEdit = true;
      //  请求详情接口
      approvalTemplateDetail({ id: row.id }).then((res) => {
        const filteredLevels = levelKeys.reduce((acc, levelKey) => {
          if (res[levelKey] && res[levelKey].length > 0) {
            const ids = res[levelKey].map((item) => item.id);
            acc.push(ids);
          }
          return acc;
        }, []);

        // 处理id select的回填只需要id
        const levelCC = res.levelCC
          .filter((item) => item.id !== undefined && item.id !== null)
          .map((item) => item.id);
        // console.log(levelCC);
        this.form = { ...res, levelCC, approvers: filteredLevels };
        // 手动设置一下
        this.applicationTypeId = res.applicationTypeId;

        this.dialogVisible = true;
      });
    },
    deleteItem(row) {
      this.$confirm("确定删除该审批流程？", "提示", { type: "warning" })
        .then(() => {
          // 删除逻辑
          approvalTemplateDelete({ id: row.id }).then(() => {
            this.$message.success("删除成功！");
            this.handleQuery();
          });
        })
        .catch(() => {});
    },
    addApprover() {
      if (this.form.approvers.length < 3) {
        this.form.approvers.push([]);
      } else {
        this.$message.warning("最多只能添加三级审批");
      }
    },
    removeApprover(index) {
      this.form.approvers.splice(index, 1);
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;

        const invalid = this.form.approvers.some(
          (list) => !list || list.length === 0
        );
        if (invalid) {
          return this.$message.error("每级审批人不能为空！");
        }

        // 如果是报废类型，只允许每个级别选择一个审批人
        if (this.isScrap) {
          for (let i = 0; i < this.form.approvers.length; i++) {
            const approver = this.form.approvers[i];
            if (approver.length > 1) {
              this.$message.warning("报废类型每个审批级别只能选择一个审批人");
              return;
            }
          }
        }

        const temp_obj = {};
        this.form.approvers.forEach((item, index) => {
          temp_obj[`level${index + 1}`] = item;
        });

        const params = {
          name: this.form.name,
          applicationTypeId: this.applicationTypeId,
          levelCC: this.form.levelCC,
          ...temp_obj,
        };

        if (this.isEdit) {
          params.id = this.form.id;
        }

        // console.log(temp_obj, params);
        approvalTemplateAddOrEdit(params).then(() => {
          this.dialogVisible = false;
          this.handleQuery();
          this.$message.success("操作成功");
        });
      });
    },
  },
  created() {
    this.handleQuery(1);
    this.getStaffList();
    this.getApprovalTypeList();
  },
};
</script>

<style scoped>
.app-container {
}
.dialog-footer {
  text-align: right;
}
</style>
